import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { Button, Confirm } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";
import { DeleteIcon } from "../../../components/common/iconography";
import { deleteChecklist } from "../../../graphql/mutations";
import { logError } from "../../../utils/appUtils";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeleteChecklistButton = ({
  record,
  backPath,
  history,
  notify,
  isDisabled,
  className,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleDelete = async (event) => {
    setIsDeleting(true);
    debugger;
    try {
      await API.graphql(
        graphqlOperation(deleteChecklist, { input: { id: record.id } }),
      );
      notify("Checklist deleted successfully", "success");
      const tab = history.location.state.tab;
      deepRedirect(history, backPath, null, { tab });
    } catch (err) {
      logError(
        "checklists:DeleteChecklistButton:handleDelete:" +
          JSON.stringify(record),
        err,
        notify,
      );
    } finally {
      setIsDeleting(false);
      setOpen(false);
    }
  };

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  return (
    <>
      <Button
        label="Delete"
        disabled={!record || isDeleting || isDisabled}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        title={"Delete Checklist"}
        content="Are you sure you want to delete this checklist?"
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
